<script setup lang="ts">
import { defineProps } from "vue";

type Props = {
  answers: Array<{
    question: string;
    answer: string;
  }>;
};

defineProps<Props>();
</script>

<template>
  <div
    class="bg-transparent border rounded-primary-radius py-6 px-8 h-full max-h-[300px] xxl:max-h-[350px] overflow-y-auto"
  >
    <div
      v-for="(item, index) in answers"
      :key="item.question"
      :class="index === answers.length - 1 ? 'mb-0' : 'mb-5'"
    >
      <h4
        class="text-[#616068] text-base leading-[26px] tracking-[0.01rem] font-medium"
      >
        {{ item.question }}
      </h4>
      <h5
        class="text-[#898790] text-base leading-[26px] tracking-[0.01rem] font-light"
      >
        {{ item.answer }}
      </h5>
    </div>
  </div>
</template>
